import { Row, Col, Button, Image } from 'react-bootstrap';
import UniversalInput from 'components/global/UniversalInput';
import MultiEmailInput from 'components/global/MultiEmailInput/MultiEmailInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import getSelectValue from 'utils/getSelectValue';
import SimpleCard from 'components/global/SimpleCard';
import FileSelector from 'components/global/FileSelector/FileSelector';
import { $form, $view } from 'signals/global.signals';
import { handleInputChange } from 'components/global/_helpers/global.helpers';
import { handleChangeDealSelect } from 'components/views/FounderRooms/_helpers/founderRooms.events';

const FounderRoomForm = ({ mode = 'create' }) => {
  const isDebtType = getSelectValue($form.value.typeOfRaise) === 'SAFE' || getSelectValue($form.value.typeOfRaise) === 'KISS' || getSelectValue($form.value.typeOfRaise) === 'Convertible Note';
  const isAcquisition = getSelectValue($form.value.typeOfRaise) === 'Acquisition';
  return (
    <Row>
      <Col lg={12} className="mb-16">
        <UniversalInput
          name="name"
          label="Room Name"
          type="text"
          required
        />
      </Col>
      <Col lg={12} className="mb-16 border-top border-gray-400 pt-16">
        <h5 className="text-gray-400">Room Details</h5>
      </Col>
      {mode === 'create' && (
        <Col lg={6} className="mb-16">
          <UniversalInput
            name="dealId"
            label="Select Deal"
            options={$view.value.dealOptions || []}
            value={$form.value.dealId}
            type="select"
            onChange={(value) => handleChangeDealSelect({ name: 'dealId', value: getSelectValue(value) })}
            disabled={mode === 'edit'}
          />
        </Col>
      )}
      <Col lg={12} className="mb-16">
        <UniversalInput
          name="description"
          label="Room Description"
          type="textarea"
          required
        />
        <div className="d-flex w-100">
          <div className="flex-grow-1" />
          <Button
            variant="outline-info d-flex align-items-center"
            size="sm"
            className="bg-transparent border-0 text-muted"
          >
            <Image src="/images/ai-icon.svg" className="me-8" width={22} height={22} />
            Fill Using AI - Coming Soon!
          </Button>
        </div>
      </Col>
      {!isAcquisition && (
        <Col lg={12} className="mb-16">
          <UniversalInput
            name="usesOfCapital"
            label="Uses of Capital"
            type="textarea"
            required
          />
          <div className="d-flex w-100">
            <div className="flex-grow-1" />
            <Button
              variant="outline-info d-flex align-items-center"
              size="sm"
              className="bg-transparent border-0 text-muted"
            >
              <Image src="/images/ai-icon.svg" className="me-8" width={22} height={22} />
              Fill Using AI - Coming Soon!
            </Button>
          </div>
        </Col>
      )}
      {!isAcquisition && (
        <Col lg={6} className="mb-16">
          <UniversalInput
            name="minimumInvestment"
            label="Minimum Investment"
            type="money"
            required
          />
        </Col>
      )}
      {isDebtType && (
        <>
          <Col lg={12} className="mb-16 border-top border-gray-400 pt-16">
            <h5 className="text-gray-400">Debt Options</h5>
          </Col>
          <Col lg={6} className="mb-16">
            <UniversalInput
              name="cap"
              label="Cap"
              type="money"
              value={isDebtType ? 0 : $form.value.cap}
              disabled={!isDebtType}
              placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
              required={isDebtType}
            />
          </Col>
          <Col lg={6} className="mb-16">
            <UniversalInput
              name="discountPercent"
              label="Discount Percent"
              type="percent"
              value={isDebtType ? 0 : $form.value.discountPercent}
              disabled={!isDebtType}
              placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
              required={isDebtType}
            />
          </Col>
          <Col lg={6} className="mb-16">
            <UniversalInput
              name="interestRate"
              label="Interest Rate"
              type="percent"
              value={$form.value.interestRate}
              disabled={!isDebtType}
              placeholder={!isDebtType ? 'Not Applicable for non-debt deals' : ''}
              required={isDebtType}
            />
          </Col>
        </>
      )}
      <Col lg={12} className="mb-16 border-top border-gray-400 pt-16">
        <h5 className="text-gray-400">Data Room</h5>
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isMrrIncluded"
          label="Include MRR?"
          type="checkbox"
          checked={$form.value.isMrrIncluded}
        />
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isArrIncluded"
          label="Include ARR?"
          type="checkbox"
          checked={$form.value.isArrIncluded}
        />
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isCashOnHandIncluded"
          label="Include Cash on Hand?"
          type="checkbox"
          checked={$form.value.isCashOnHandIncluded}
        />
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isCurrent"
          label="Include Investments?"
          type="checkbox"
          checked={$form.value.isCurrent}
        />
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isLiabilitiesIncluded"
          label="Include Liabilities?"
          type="checkbox"
          checked={$form.value.isLiabilitiesIncluded}
        />
      </Col>
      <Col lg={4} md={6} className="mb-16">
        <UniversalInput
          name="isOtherAssetsIncluded"
          label="Include Other Assets?"
          type="checkbox"
          checked={$form.value.isOtherAssetsIncluded}
        />
      </Col>
      <Col lg={4} md={6} className="d-flex justify-content-start" style={{ height: '32px' }}>
        <Button
          size="sm"
          variant="link"
          as="a"
          href="/founder/data-room?tab=Financials"
          target="_blank"
          rel="noopener noreferrer"
          className="text-info p-0"
        >
          <span className="me-8">Review Financials</span>
          <FontAwesomeIcon icon={faUpRightFromSquare} className="ms-4" size="sm" />
        </Button>
      </Col>
      <Col lg={12} className="mb-16 border-top border-gray-400 pt-16">
        <UniversalInput
          name="dataVaultInclusion"
          label="Data Vault Files"
          type="select"
          value={$form.value.dataVaultInclusion}
          options={[
            { label: 'Include All Files in Data Vault', value: 'all' },
            { label: 'Select Files to Include', value: 'select' },
          ]}
        />
      </Col>
      {getSelectValue($form.value.dataVaultInclusion) === 'select' && (
        <Col className="mb-16">
          <SimpleCard>
            <FileSelector
              folders={$view.value.folders || []}
              onSelectionChange={(selectedDocs) => {
                handleInputChange({ name: 'filesToInclude', value: selectedDocs });
              }}
              initialSelectedDocs={$form.value.filesToInclude || []}
            />
          </SimpleCard>
        </Col>
      )}
      {/* This is not ready for production yet. */}
      {/* <Col lg={12} className="mb-16 border-top border-gray-400 pt-16">
        <h5 className="text-gray-400">Visibility</h5>
      </Col> */}
      {/* <Col lg={4} className="mb-16">
        <UniversalInput
          name="isPublic"
          label="Is Public"
          type="checkbox"
          checked={$form.value.isPublic}
        />
      </Col> */}
      {!$form.value.isPublic && (
        // This is not ready for production yet
        <div className="d-none">
          <Col lg={12} className="mb-16 d-flex justify-content-start align-items-center">
            <div className="">Restrict by:</div>
            <div>
              <Button
                variant="transparent"
                className={`me-2 ${$form.value.usePasscode ? 'fw-bold text-primary' : 'text-white'}`}
                onClick={() => handleInputChange({ name: 'usePasscode', value: true })}
                type="button"
              >
                Passcode
              </Button>
              <span className="text-white mx-2">|</span>
              <Button
                variant="transparent"
                className={`ms-2 ${!$form.value.usePasscode ? 'fw-bold text-primary' : 'text-white'}`}
                onClick={() => handleInputChange({ name: 'usePasscode', value: false })}
                type="button"
              >
                Restrict by Email
              </Button>
            </div>
          </Col>
          {$form.value.usePasscode ? (
            <Col lg={12} className="mb-16">
              <UniversalInput
                name="passcode"
                label="Passcode"
                type="password"
              />
            </Col>
          ) : (
            <Col lg={12} className="mb-16">
              <MultiEmailInput
                name="emailsWithAccess"
                label="Emails with Access"
                value={$form.value.emailsWithAccess}
                onChange={handleInputChange}
                options={$view.value.investorOptions || []}
              />
            </Col>
          )}
        </div>
      )}
    </Row>
  );
};

export default FounderRoomForm;
